
import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const HeaderContainer = styled.header`
  background: var(--bg-card);
  border-bottom: 1px solid var(--border-light);
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: var(--shadow-header);
`;

export const HeaderContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 68px;

  @media (max-width: 768px) {
    padding: 0 16px;
    height: 58px;
  }

  /* Tablet y laptop chica: con los 8 enlaces del portal de empresa el menú no
     cabe junto al logo y al usuario; pasa a una segunda fila en vez de ensanchar
     la página. */
  @media (min-width: 769px) and (max-width: 1240px) {
    flex-wrap: wrap;
    height: auto;
    min-height: 68px;
    padding: 8px 24px;
    row-gap: 4px;
  }
`;

export const Logo = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  flex-shrink: 0;

  img {
    height: 26px;
    width: auto;
    max-width: 100%;

    @media (max-width: 768px) {
      height: 20px;
    }

    @media (max-width: 480px) {
      height: 17px;
    }
  }
`;

export const Navigation = styled.nav`
  display: flex;
  gap: 4px;
  align-items: center;

  @media (max-width: 768px) {
    display: none;
  }

  @media (min-width: 769px) and (max-width: 1240px) {
    order: 3;
    flex-basis: 100%;
    flex-wrap: wrap;
  }
`;

export const NavLink = styled(Link)`
  color: var(--text-secondary);
  text-decoration: none;
  font-weight: 500;
  font-family: var(--font-brand);
  font-size: var(--text-sm);
  padding: 6px 12px;
  border-radius: var(--radius-md);
  transition: color var(--transition-fast), background var(--transition-fast);

  &:hover {
    color: var(--primary);
    background: var(--bg-section);
  }

  &.active {
    color: var(--primary);
    background: var(--bg-section);
    font-weight: 700;
  }
`;

export const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;

  /* Separador visual antes de la zona de usuario */
  &::before {
    content: '';
    display: block;
    width: 1px;
    height: 24px;
    background: var(--border-light);
    margin-right: 4px;
  }

  button { white-space: nowrap; }

  @media (max-width: 768px) {
    font-size: 12px;
    gap: 6px;
    &::before { display: none; }
  }

  @media (max-width: 480px) {
    button { padding: 7px 12px; font-size: var(--text-xs); }
  }
`;

export const UserName = styled.span`
  font-size: var(--text-sm);
  color: var(--text-secondary);
  font-weight: 500;

  @media (max-width: 480px) {
    display: none;
  }
`;

